(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["klaviyo-form"] && !Shopify.designMode) return;
  try {
    var klaviyoForms = document.querySelectorAll('form.klaviyo-form');
klaviyoForms.forEach((item)=>{
  item.onsubmit = function (e) {
    e.preventDefault();
    var entered_email = item.querySelector('input[type="email"]');
    var buttonSubmit = item.querySelector('button.submit-button');
    var buttonLoading = item.querySelector('button.loading-button');
    var listID = item.dataset.klaviyoListId;
    
    if(entered_email.value!="" && listID) {
      var parentStep = item.closest('div.klaviyo-form-step');
      var errorBox = item.querySelector('div.alert');

      errorBox.classList.add('d-none');
      
      buttonLoading.classList.remove('d-none');
      buttonSubmit.classList.add('d-none');
      var payload = {
        "data": {
          "type": "subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "subscriptions": {
                    "email": {
                      "marketing": {
                        "consent": "SUBSCRIBED"
                      }
                    },
                    "sms": {
                      "marketing": {
                        "consent": "SUBSCRIBED"
                      },
                      "transactional": {
                        "consent": "SUBSCRIBED"
                      }
                    }
                  },
                  "email": entered_email.value
                }
              }
            }
          },
          "relationships": {
            "list": {
              "data": {
                "type": "list",
                "id": listID
              }
            }
          }
        }
      }
      
      var requestOptions = {
        method: 'POST',
        headers: {
          "accept": "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
          "revision":"2025-04-15"
        },
        body: JSON.stringify(payload),
      };
      
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=UQuVPh", requestOptions)
        .then(res => {
          if(res.status == 202) {
            parentStep.classList.add('d-none');
            parentStep.nextElementSibling.classList.add('d-block');
          } else {
            errorBox.classList.remove('d-none');
            buttonLoading.classList.add('d-none');
            buttonSubmit.classList.remove('d-none');
          }
        })
        .catch(err => console.error(err));
    }
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-info"] && !Shopify.designMode) return;
  try {
    if(typeof ratingSnippet === "function") {
  ratingSnippet("ruk_rating_snippet", {
    store: "www.tropicfeel.com",
    mode: "minimal",
    color: "#262626",
    linebreak: false,
    text: "Reviews",
    singularText: "Review",
    lang: "en",
    usePolaris: false,
    showEmptyStars: false,
  });
}

var product_info = document.querySelector('.section-pdp');
product_info.addEventListener('click', (e) => {
  var targetElement = e.target;
  if(targetElement.classList.contains('welcome-banner-link')) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.openForm(targetElement.dataset.klaviyoFormid);
  }
});
  } catch(e) { console.error(e); }
})();

})();
